import { useMemo } from 'react';

import { useStatusContext } from 'pages/Status/context';

import { getAlliumState } from './helpers';

import { LenderStatus } from '../constants';

interface AlliumStatusContentHook {
  state: LenderStatus;
}

export default function useAlliumStatusContent(): AlliumStatusContentHook {
  const { job, credit, deposit, isLoading } = useStatusContext();

  const state = useMemo((): LenderStatus => {
    if (isLoading || !job || !credit) return 'loading';
    return getAlliumState(job, credit, deposit);
  }, [isLoading, job, credit, deposit]);

  return {
    state,
  };
}
